import { Routes, Route } from "react-router-dom";
import { useEffect, Suspense, lazy } from "react";
import HomePage from "./Pages/HomePage";
import Login from "./Pages/Auth/Login";
import CartPage from "./Pages/CartPage";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Toaster } from "react-hot-toast";
import { createBrowserHistory } from 'history';
import ReactGA from "react-ga";

const AboutPage = lazy(() => import("./Pages/AboutPage"));
const ServicePage = lazy(() => import("./Pages/ServicePage"));
const Gifting = lazy(() => import("./Pages/Gifting"));
const Dashboard = lazy(() => import("./Pages/User/Dashboard"));
const Orders = lazy(() => import("./Pages/User/Orders"));
const ProductDetails = lazy(() => import("./Pages/ProductDetails"));
const Categories = lazy(() => import("./Pages/Categories"));
const CategoryProduct = lazy(() => import("./Pages/CategoryProduct"));
const Wishlist = lazy(() => import("./Pages/User/Wishlist"));
const ProductPage = lazy(() => import("./Pages/ProductList"));
const CheckoutPage = lazy(() => import("./Pages/CheckoutPage"));
const PlantationServices = lazy(() => import("./Components/Sub_Home/PlantationService"));
const Farmland = lazy(() => import("./Components/Sub_Home/Farmland"));
const Villa = lazy(() => import("./Components/Sub_Home/Villa"));
const Training = lazy(() => import("./Components/Sub_Home/Training"));
const PaymentFailurePage = lazy(() => import("./Pages/PaymentFailurePage"));
const PaymentSuccessPage = lazy(() => import("./Pages/PaymentSuccessPage"));
const PrivacyPolicy = lazy(() => import("./Pages/PrivacyPolicy"));
const ReturnRefundPolicy = lazy(() => import("./Pages/ReturnRefundPolicy"));
const TermsAndConditions = lazy(() => import("./Pages/TermsAndConditions"));
const SandalwoodFarmlandPlantation = lazy(() => import("./Components/Sub_Home/SandalwoodFarmlandPlantation"));
const SandalwoodMaintenance = lazy(() => import("./Components/Sub_Home/SandalwoodMaintenance"));
const SandalwoodHeartwoodAssessment = lazy(() => import("./Components/Sub_Home/SandalwoodHeartwoodAssessment"));
const SandalwoodConsultancy = lazy(() => import("./Components/Sub_Home/SandalwoodConsultancy"));
const SandalwoodCsr = lazy(() => import("./Components/Sub_Home/SandalwoodCsr"));
const ContactWrapper = lazy(() => import("./Pages/ContactWrapper"));
const BookFlip = lazy(() => import("./Components/Sub_Home/BookFlip"));
const OrderConfirmedPage = lazy(() => import("./Pages/OrderConfirmedPageCod"));
const OurProjects = lazy(() => import("./Pages/OurProjects"));


// const history = createBrowserHistory();
// ReactGA.initialize('G-7BYT1840KG');
// history.listen((location, action) => {
//     ReactGA.pageview(location.pathname + location.search);
//     console.log(location.pathname);
// });

ReactGA.initialize("G-RYP8BVDEZZ")
const browserHistory = createBrowserHistory()
browserHistory.listen((location, action) => {
  ReactGA.pageview(location.pathname + location.search)
})

function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])
  return (
    <>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/PaymentSuccess" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><PaymentSuccessPage /></Suspense>} />
          <Route path="/PaymentFailure" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><PaymentFailurePage /></Suspense>} />
          <Route path="/order-confirmed" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><OrderConfirmedPage /></Suspense>} />
          <Route path="/PlantationServices" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><PlantationServices /></Suspense>} />
          <Route path="/FarmlandPlantation" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><SandalwoodFarmlandPlantation /></Suspense>} />
          <Route path="/Maintenance" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><SandalwoodMaintenance /></Suspense>} />
          <Route path="/HeartwoodAssessment" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><SandalwoodHeartwoodAssessment /></Suspense>} />
          <Route path="/Consultancy" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><SandalwoodConsultancy /></Suspense>} />
          <Route path="/CSR" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><SandalwoodCsr /></Suspense>} />
          <Route path="/SandalwoodPlantation" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><Farmland /></Suspense>} />
          <Route path="/Villa_Bungalow" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><Villa /></Suspense>} />
          <Route path="/Training_Modules" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><Training /></Suspense>} />
          <Route path="/products" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><ProductPage /></Suspense>} />
          <Route path="/product/:slug" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><ProductDetails /></Suspense>} />
          <Route path="/categories" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><Categories /></Suspense>} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><CheckoutPage /></Suspense>} />
          <Route path="/bookflip" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><BookFlip /></Suspense>} />
          <Route path="/category/:slug" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><CategoryProduct /></Suspense>} />

          <Route path="/dashboard">
            <Route path="user/profile" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><Dashboard /></Suspense>} />
            <Route path="user/orderhistory" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><Orders /></Suspense>} />
            <Route path="user/wishlist" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><Wishlist /></Suspense>} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><AboutPage /></Suspense>} />
          <Route path="/services" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><ServicePage /></Suspense>} />
          <Route path="/har-ghar-chandan" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><Gifting /></Suspense>} />
          <Route path="/our-work" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><OurProjects /></Suspense>} />
          <Route path="/contact-us" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><ContactWrapper /></Suspense>} />
          <Route path="/privacy-policy" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><PrivacyPolicy /></Suspense>} />
          <Route path="/Return-Refund-policy" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><ReturnRefundPolicy /></Suspense>} />
          <Route path="/Terms-Conditions-policy" element={<Suspense fallback={<div style={{minHeight: '100vh'}} />}><TermsAndConditions /></Suspense>} />
        </Routes>
      <Toaster />
    </>
  );
}

export default App;
